/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Paused/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import ResumeAction from './ResumeAction/index'
import ResumeDate from './ResumeDate/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Paused({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/DentalMonitoring/Content/Paused"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceS}
 text="Monitoring paused"
/>
<div
  data-testid="Paused.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z2g3cIN': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<ResumeDate
  viewPath={`${viewPath}/ResumeDate`}
/>
<ResumeAction
  viewPath={`${viewPath}/ResumeAction`}
/>
</div>
{children}
</React.Fragment>)
}